<template>
  <div class="car-archive">
    <div class="search-warehouse">
      <div class="screen">
        <el-input class="white w200" v-model="search.batchNo" placeholder="请输入批次号"></el-input>
        <el-select class="white w200" clearable v-model="search.brandId" placeholder="请选择品牌" filterable 
            v-lazy-load-dropdown="handleScrollDropdown">
          <el-option
            v-for="item in brandTypeOptionsList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-date-picker
          class="white w200"
          v-model="search.arrivalDate"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd">
        </el-date-picker>
        <el-button class="btn-blue" @click="onSearch">搜索</el-button>
      </div>
      <div class="operation-btn">
        <el-button class="btn-white" @click="addBatch('add')"
          >新增批次号</el-button
        >
      </div>
    </div>
    <div class="table">
      <el-table ref="table" :data="batchList" style="width: 100%">
        <el-table-column 
          v-for="(item, index) in tableTitleList"
          :key="index"
          :label="item.label"
          :prop="item.prop"
        >
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button class="btn-text" type="text" @click="mod(scope.row)">编辑</el-button>
            <el-button class="btn-text" type="text" @click="lookDetails(scope.row)">详情</el-button>
            <el-upload
              element-loading-text="文件导入中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(0, 0, 0, 0.8)"
              class="upload"
              ref="upload"
              action="#"
              :show-file-list="false"
              :auto-upload="true"
              :before-upload="(file) => uploadExcel(file, scope.row.id)"
            >
              <el-button class="btn-text" type="text" slot="trigger">导入</el-button>
            </el-upload>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="footer">
      <pagination-tpl
        :total="total"
        :currentPage="currentPage"
        :pageSize="pageSize"
        @queryChange="queryChange"
      ></pagination-tpl>
    </div>

    
  <!-- 新增/编辑 -->
  <el-dialog :title="type ==='add'?'新增批次号':'编辑'" top="18vh" :visible.sync="promptingDialog" width="420px" :before-close="closeOrderDown">
    <div class="border"></div>
    <el-form
      class="batch-form"
      :rules="batchFormRules"
      ref="batchForm"
      :model="batchForm"
    >
      <el-form-item label="批次号" prop="batchNo">
        <el-input class="white" v-model="batchForm.batchNo" placeholder="请输入批次号"></el-input>
      </el-form-item>
      <el-form-item label="品牌" prop="brandId">
        <el-select class="white" clearable v-model="batchForm.brandId" placeholder="请选择品牌" filterable
        v-lazy-load-dropdown="handleScrollDropdown">
          <el-option
            v-for="item in brandTypeOptionsList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="作业类型" prop="jobType">
        <el-select class="white"
          v-model="batchForm.jobType" placeholder="作业类型">
          <el-option v-for="item in assignmentTypeList" :key="item.id" :label="item.name"
            :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="到港时间" prop="arrivalDate">
        <el-date-picker
          class="white w200"
          v-model="batchForm.arrivalDate"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-form-item>
    </el-form>
    <div class="dialog-footer">
      <el-button class="btn-white" @click="closeOrderDown"
        >取消</el-button
      >
      <el-button class="btn-blue" @click="confirmOrderDown('batchForm')"
        >确定</el-button
      >
    </div>
  </el-dialog>
  </div>
</template>

<script>
import { modifyNetTitle } from "common/js/util";
import PaginationTpl from "components/base/PaginationTpl";
import BrandMixins from "common/mixins/smart-vehicle-inspection/brand";
import SmartVehicleInspection from "models/smart-vehicle-inspection/smart-vehicle-inspection";
export default {
  mixins: [BrandMixins],
  data() {
    return {
      search: {
        batchNo: '',
        brandId: '',
        arrivalDate: ''
      },
      batchList: [],
      tableTitleList: [
        {label: '批次号', prop: 'batchNo'},
        {label: '品牌', prop: 'brandName'},
        {label: '计划采集车辆', prop: 'planCount'},
        {label: '应已采集', prop: 'collectedCount'},
        {label: '到港时间', prop: 'arrivalDate'},
        {label: '作业类型', prop: 'assignmentTypeVal'}
      ],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      assignmentTypeList: [
        {id:1, name: '接收检验'}
        // {id:2, name: '移交检验'}
      ],
      
      promptingDialog: false,
      batchForm: {
        id: '',
        batchNo: "",
        brandId: "",
        jobType: 1,
        arrivalDate: ""
      },
      batchFormRules: {
        batchNo: [
          { required: true, message: "请输入批次号", trigger: "blur" },
        ],
        brandId: [
          { required: true, message: "请选择品牌", trigger: "change" },
        ],
        jobType: [
          { required: true, message: "请选择作业类型", trigger: "change" },
        ]
      },
      type: ''
    };
  },
  components: {
    PaginationTpl
  },
  created() {
    modifyNetTitle('批次管理')
    this.initBatchList();
    this.initBrandList();
  },
  methods: { 
    initBatchList() {
      let data = this.search
      data.pageNo = this.currentPage
      data.pageSize = this.pageSize
      SmartVehicleInspection.getBatchList(data).then(res => {
        if (res.success) {
          const { records, total, size } = res.result
          this.pageSize = size;
          this.total = total;
          let arr = [];
          records.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.batchNo = value.batchNo;
            obj.brandId = value.brandId;
            obj.brandName = value.brandName;
            obj.planCount = value.planCount;
            obj.collectedCount = value.collectedCount;
            obj.arrivalDate = value.arrivalDate;
            obj.jobType = value.jobType;
            obj.assignmentTypeVal = value.jobType === 1?'接收检验':'移交检验';
            arr.push(obj);
          });
          this.batchList = arr;
        }
      })
    },

    //翻页
    queryChange(data) {
      this.currentPage = data.currentPage;
      this.initBatchList();
    },

    onSearch() {
      this.initBatchList()
    },

    lookDetails(row) {
      this.$router.push({
        path: '/vehicle/homework-center/batch/batch-details',
        query: {
          id: row.id,
        }
      })
    },

    mod(row) {
      this.type = 'mod'
      const { id, batchNo, brandId, jobType, arrivalDate } = row
      this.batchForm.id = id
      this.batchForm.batchNo = batchNo
      this.batchForm.brandId = brandId
      this.batchForm.jobType = jobType
      this.batchForm.arrivalDate = arrivalDate
      this.promptingDialog = true
    },
    
    closeOrderDown() {
      this.batchForm = {
        id: '',
        batchNo: "",
        brandId: "",
        jobType: 1,
        arrivalDate: ""
      }
      this.$nextTick(() => {
        this.$refs.batchForm.clearValidate();
      });
      this.promptingDialog = false
    },
    confirmOrderDown(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            id: this.batchForm.id,
            batchNo: this.batchForm.batchNo,
            brandId: this.batchForm.brandId,
            jobType: this.batchForm.jobType,
            arrivalDate: this.batchForm.arrivalDate,
          }
          if (this.type === 'mod') {
            SmartVehicleInspection
              .postModBatch(data)
              .then(res => {
                if (res.success) {
                  this.initBatchList()
                  this.closeOrderDown()
                } else {
                  this.$message.error(res.message);
                }
              })
          } else {
            SmartVehicleInspection
              .postAddBatch(data)
              .then(res => {
                if (res.success) {
                  this.initBatchList()
                  this.closeOrderDown()
                } else {
                  this.$message.error(res.message);
                }
              })
          }
        } else {
          console.log("error submit!!");
        }
      });
    },
    // 导入
    uploadExcel(file, id) {
      var formData = new FormData();
      formData.append("file", file);
      formData.append("id", id);
      SmartVehicleInspection
        .postUploadBatchExcel(id, formData)
        .then(res => {
          if (res.success) {
            this.$message.success("导入成功");
          } else {
            this.$confirm(res.message, "提示", {
              showCancelButton: false,
              confirmButtonText: "确定",
              type: "warning"
            }).then(() => {});
          }
        })
        .catch(() => {
          this.$message.error("导入失败");
        });
      return false;
    },
    addBatch(type) {
      this.type = type
      this.promptingDialog = true
    }
  }
};
</script>
<style lang="scss" scoped>
.car-archive {
  flex: 1;
  background: #fff;
  border-radius: 4px;
  padding: 16px;
  box-sizing: border-box;
  .search-warehouse {
    margin-bottom: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .screen {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .w200 {
        width: 200px;
        margin-right: 16px;
      }
    }
  }
  .table .el-table ::v-deep.el-table__body-wrapper .el-table__body tr td .cell, 
  .table .el-table ::v-deep.el-table__fixed-body-wrapper .el-table__body tr td .cell {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .el-button--text {
    margin-left: 10px;
  }
  .footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 16px;
  }
  .el-form {
    margin-bottom: 20px;
    .el-form-item {
      .el-form-item__label {
        line-height: 20px;
      }
      .el-form-item__content {
        width: 100%;
        .el-date-editor,
        .el-radio-group,
        .el-select {
          width: 100%;
        }
      }
    }
  }
  .dialog-footer {
    margin-top: 16px;
    border-top: 1px solid #f7f7f7;
    padding-top: 16px;
    display: flex;
    justify-content: center;
    .btn-white {
      margin-right: 20px;
    }
  }
}
</style>
